import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import { UNASSIGNED } from 'lib/import/map_import_headers';

class ImportFormSelectColumns extends PureComponent {
  static propTypes = {
    headersOpciones: PropTypes.array.isRequired,
    headersSelect: PropTypes.array.isRequired,
    handleHeaderChange: PropTypes.func.isRequired,
  };

  render = () => {
    return (
      <div className="container">
        <div className={'row justify-content-lg-center'}>
          {this.props.headersSelect.map(
            (
              select,
              index // Headers necesarios con su posible columna del csv asignada.
            ) => (
              <div className="col-md-4 mb-2 f-flex justify-content-center">
                <Common.Form.FieldSelect
                  autoFocus={true}
                  label={select.key}
                  name={index}
                  handleChange={(e) => {
                    this.props.handleHeaderChange(select, e);
                  }}
                  value={
                    select.posicion === UNASSIGNED
                      ? ''
                      : this.props.headersOpciones[select.posicion].index
                  }
                  noEmptyOption={true}
                >
                  {/* The file does not have this column (e.g. an old template without
                      referencia_dms). Disabled: picking it would make handleHeaderChange
                      write headers[""]. */}
                  {select.posicion === UNASSIGNED && (
                    <option value="" disabled>
                      {this.props.t('import.unassigned')}
                    </option>
                  )}
                  {this.props.headersOpciones.map((key) => (
                    <option value={key.index}>{key.value}</option>
                  ))}{' '}
                  {/* Columnas del CSV a intentar importar */}
                </Common.Form.FieldSelect>
              </div>
            )
          )}
        </div>
      </div>
    );
  };
}

export default translate()(ImportFormSelectColumns);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/form/ImportFormSelectColumns.js